import { useState } from 'react';

import Checkbox from 'components/shared/Checkbox/Checkbox';
import Icon from 'components/shared/Icon/Icon';

import Hr from '../Hr/Hr';
import cs from 'classnames';

/**
 * @param {import('./lib/propTypes').AcknowledgementListProps} props
 */

const AcknowledgementList = ({
  header,
  banner,
  items,
  renderItem,
  acknowledgement,
  showBanner = true,
  showHr = true,
  onBannerClose
}) => {
  const [isBannerVisible, setIsBannerVisible] = useState(showBanner);

  const handleBannerClose = () => {
    setIsBannerVisible(false);
    if (onBannerClose) {
      onBannerClose();
    }
  };

  return (
    <>
      {header && (
        <div className="flex flex-col gap-2 pt-6">
          <span className="text-base font-500">{header.title}</span>
          <p className="text-sm font-400">{header.description}</p>
        </div>
      )}

      {banner && isBannerVisible && (
        <div className="mb-3 flex gap-2 rounded-lg border border-solid border-neutral-200 p-3 shadow-sm shadow-neutral-200">
          <Icon
            icon="info-circle-filled"
            className="self-start"
            customColor={banner.iconColor || '#0BA5EC'}
            size={18}
          />
          <div className="flex flex-col gap-1">
            <span className="text-sm font-500">{banner.title}</span>
            <p className="text-xs font-400">{banner.description}</p>
          </div>
          <Icon icon="close-linear" className="self-start" size={18} onClick={handleBannerClose} />
        </div>
      )}

      {items?.length > 0 && (
        <div className="flex flex-col gap-3 pb-4 pt-2">{items.map((item) => renderItem(item))}</div>
      )}

      {showHr && <Hr className="my-4" />}

      <div className={cs('flex items-start gap-[7px] py-6', showHr && 'pb-6 pt-0')}>
        <div className="flex flex-shrink-0 items-center pt-0.5">
          <Checkbox
            disabled={acknowledgement.isDisabled}
            isChecked={acknowledgement.isChecked}
            size={18}
            onChange={acknowledgement.onChange}
          />
        </div>
        <div className="text-sm leading-5">
          {typeof acknowledgement.text === 'string' ? (
            <div>{acknowledgement.text}</div>
          ) : (
            acknowledgement.text
          )}
        </div>
      </div>
    </>
  );
};

export default AcknowledgementList;
